import * as React from "react";

import styled from "styled-components";

import {Colors, Fonts} from "../../Styles";

const StyledSynonymHint = styled.div`
    position: relative;
    font-family: ${Fonts.theinhardt};
    font-size: 17px;
    text-align: center;
    margin: 14px;
    padding: .1px;

    &:before,
    &:after {
        content: "–";
        display: block;
        height: 4px;
        width: 50px;
        background: #000;
        overflow: hidden;
        margin: 9px auto;
    }

    &:before {
        margin-bottom: 40px;
    }
    &:after {
        margin-top: 40px;
    }
`;

const StyledTitle = styled.h2`
    font-size: inherit;
    font-family: inherit;
    margin: 1em;
`;

const StyledMarking = styled.span`
    background: ${Colors.ufoGreen};
`;

export const StyledButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    background: transparent;
    height: 24px;
    line-height: 21px;
    font-family: ${Fonts.theinhardt};
    font-size: 21px;
    padding: 0;
    width: 24px;
    display: block;
    cursor: pointer;
`;

export const SynonymHint = (props: {onClick: (e: React.MouseEvent<HTMLButtonElement>) => void}) => {
    return (
        <StyledSynonymHint>
            <StyledTitle>Kennen Sie schon unsere neue Synonymsuche?</StyledTitle>
            <StyledMarking>Markieren</StyledMarking> Sie einfach ein Wort in Ihrem Text, um passende Vorschläge zu erhalten.
            <StyledButton onClick={props.onClick}>❌</StyledButton>
        </StyledSynonymHint>
    );
}
